import {Component, ViewChild} from '@angular/core';
import {AlertController, IonicPage, LoadingController, NavController, NavParams, ViewController,} from 'ionic-angular';
import {UtilProvider} from '../../../providers/util/util';
import {PhotoclipPage} from '../../photoclip/photoclip';
import {HttpProvider} from '../../../providers/http/http';
import {CustomLoadingProvider} from "../../../providers/custom-loading/custom-loading";
import {MyAlertProvider} from "../../../providers/my-alert/my-alert";
import {global} from "../../../environments/global";

/**
 * Generated class for the PullNewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  defaultHistory: ['PullHomePage']
})
@Component({
  selector: 'page-pull-new',
  templateUrl: 'pull-new.html',
})
export class PullNewPage {
  curIndex: number = 1;
  maxIndex: number = 3;

  pages = new Array(this.maxIndex);

  /* 第一页 */
  //主题名称
  eventTitle: string = '';

  //今天的时间
  todayTime = this.util.getISODate(UtilProvider.DATE_NOW);

  //有效期
  startTime = this.util.getISODate(UtilProvider.DATE_NOW);
  endTime = this.util.getISODate(
    UtilProvider.DATE_1_DAY_LATTER,
    new Date(this.startTime)
  );

  //可选的 最小的 结束时间
  endMinTime = this.util.getISODate(
    UtilProvider.DATE_1_DAY_LATTER,
    new Date(this.startTime)
  );
  //可选的 最大的 结束时间
  endMaxTime = this.util.getISODate(
    UtilProvider.DATE_10_DAYS_LATTER,
    new Date(this.startTime)
  );

  //活码图片容器
  @ViewChild('qrWrapper') qrWrapper;

  //当前的活码图片
  qrCodeUrl: string = './assets/imgs/test_qr.png';

  //当前海报的图片
  postImgUrl: string;

  /* 第二页 */
  //群名称
  groupName: string = '';
  //起始编号
  groupStartNum: number;
  //群名保护
  nameProtect: boolean = true;
  //重复入群保护
  repeatProtect: boolean = true;

  /* 第三页 */
  //话术数据
  autoWords = {
    fission: {
      checked: true,
      word1:
        '',
      word2:
        '',
    },
    condition: {
      checked: true,
      word:'',
    },
    attract: {
      checked: true,
      word:'',
    },
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public util: UtilProvider,
    public alertCtrl: AlertController,
    public viewCtrl: ViewController,
    public http: HttpProvider,
    public myAlertService:MyAlertProvider,
    public csLoader: CustomLoadingProvider,
    public loadingCtrl: LoadingController,
  ) {



  }

  ionViewWillLoad(){
    this.csLoader.showLoader();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PullNewPage');

    this.initEvent();

  }

  initEvent(){
    this.http.hPost('/events_init').subscribe(res => {
      try {
        this.csLoader.dismissLoader();

        this.qrCodeUrl = res.content.alive_qrcode_url;
        this.autoWords.fission.word1 = res.content.fission_word_1;
        this.autoWords.fission.word2 = res.content.fission_word_2;
        this.autoWords.condition.word = res.content.condition_word;
        this.autoWords.attract.word = res.content.pull_people_word;

        // this.util.urlToQrcode(this.qrWrapper.nativeElement, qrStrUrl);

        //这一步是异步的
        // setTimeout(()=>{
        //   this.qrCodeUrl = this.qrWrapper.nativeElement.children[1].src;
        //   console.log(this.qrCodeUrl);
        // }, 300);
        //消除 loader
        // console.log('qrCode:' + this.qrCodeUrl);
      }
      catch (e){
        console.log(e);
      }
    }, err=> {
      this.csLoader.dismissLoader();

      let alertObj = {
        type: 'error',
        title: '创建拉新任务失败',
        message: global.bot_name + '服务器遇到点难题，我们正在抢修...',
        success: {
          text: '知道了',
        }
      };
      this.myAlertService.showAlert(alertObj);
    });
  }

  nextStep() {
    switch (this.curIndex) {
      //验证第一页
      case 1: {
        if (!this.eventTitle) {
          this.util.alertHintMsg(this.alertCtrl, '提示', '请输入主题名称');
          return;
        }

        this.afterValidating();
        break;
      }
      //验证第二页
      case 2: {
        if (!this.groupName) {
          this.util.alertHintMsg(this.alertCtrl, '提示', '请输入群名称');
          return;
        }
        if (this.groupStartNum &&
          (this.groupStartNum < 0 ||
          this.groupStartNum > 1000 ||
          !Number.isInteger(Number(this.groupStartNum)))
        ) {
          this.util.alertHintMsg(
            this.alertCtrl,
            '提示',
            '请将起始编号设置为0-1000的整数'
          );
          return;
        }

        this.http.hPost('/events_same_start_name', {start_name: this.groupName}).subscribe(res =>{
          if(res.err_code === 0){
            if(!res.content){
              this.afterValidating();
            } else {
              this.util.alertHintMsg(
                this.alertCtrl,
                '提示',
                '您已经有一个活动使用了这个群名，请更换群名'
              );
            }
          }
        },err => {

        });
        break;
      }
      //第三页不需要验证
      case 3: {
        this.afterValidating();
        break;
      }
    }


  }

  afterValidating(){
    if (this.curIndex == this.maxIndex) {
      this.submitForm();
    } else {
      this.curIndex++;
    }
  }

  /**
   * 跳往截屏页面*/
  photoClip() {

    this.navCtrl.push(PhotoclipPage, {
      qrCode: this.qrCodeUrl,
      onClipFinished: postImgUrl => {
        console.log(postImgUrl);
        this.postImgUrl = postImgUrl;
      },
    });
  }

  onStartTimeChange() {
    //重置结束时间范围
    this.endMinTime = this.util.getISODate(
      UtilProvider.DATE_1_DAY_LATTER,
      new Date(this.startTime)
    );
    this.endMaxTime = this.util.getISODate(
      UtilProvider.DATE_10_DAYS_LATTER,
      new Date(this.startTime)
    );
    if (
      new Date(this.endMinTime).getTime() > new Date(this.endTime).getTime()
    ) {
      //重置 endTime
      this.endTime = this.endMinTime;
    }
    if (
      new Date(this.endMaxTime).getTime() < new Date(this.endTime).getTime()
    ) {
      //重置 endTime
      this.endTime = this.endMaxTime;
    }
  }

  /**
   * 结束本模块，跳向下一个模块*/
  private _finish(){
    let index = this.navCtrl.indexOf(this.viewCtrl);
    this.navCtrl.insert(index, 'PullManageHomePage');
    this.navCtrl.pop();
  }

  /**
   * 提交表单*/
  submitForm(){
    let loading = this.loadingCtrl.create({
      spinner: 'bubbles',
      content: '正在提交，请稍候'
    });

    loading.present();
    let params = {
      "event_title": this.eventTitle,
      "start_time": this.util.getUnixByDate(new Date(this.startTime)), //开始时间 unix 单位： 秒
      "end_time": this.util.getUnixByDate(new Date(this.endTime)),
      "poster_raw": this.postImgUrl,
      "start_name": this.groupName,
      "start_index": this.groupStartNum===undefined? 1 : Number(this.groupStartNum), //群后缀开始编号
      "chatroom_name_protect": this.nameProtect,  //群名保护
      "chatroom_repeat_protect": this.repeatProtect, //重复入群保护
      "need_fission": this.autoWords.fission.checked,
      "fission_word_1": this.autoWords.fission.word1,
      "fission_word_2": this.autoWords.fission.word2,
      "need_condition_word": this.autoWords.condition.checked,
      "condition_word": this.autoWords.condition.word,
      "need_pull_people": this.autoWords.attract.checked,
      "pull_people_word": this.autoWords.attract.word,
    };
    this.http.hPost('/events_create', params).subscribe(res=>{
      if(res.err_code === 0){
        loading.dismiss();
        this._finish();
      }
    },err =>{
      loading.dismiss();

    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/pull/pull-new/pull-new.ts